import { Suspense } from "react"
import { Route, Routes } from "react-router-dom"
import { AppProviders } from "@/components/app/AppProviders"
import { Spinner } from "@/components/app/Spinner"
import ErrorBoundary from "@/components/ErrorBoundary"
import { lazyRetry } from "@/lib/lazyRetry"
import PostPage from "@/pages/app/PostPage"
import UserPage from "@/pages/app/UserPage"

const AppLayout = lazyRetry(() => import("@/pages/app/AppLayout"))
const WorldEntryPage = lazyRetry(() => import("@/pages/WorldEntryPage"))
const FeedPage = lazyRetry(() => import("@/pages/app/FeedPage"))
const FollowListPage = lazyRetry(() => import("@/pages/app/FollowListPage"))
const SearchPage = lazyRetry(() => import("@/pages/app/SearchPage"))
const NotificationsPage = lazyRetry(() => import("@/pages/app/NotificationsPage"))
const WalletPage = lazyRetry(() => import("@/pages/app/WalletPage"))
const WalletTokensPage = lazyRetry(() => import("@/pages/app/WalletTokensPage"))
const ReferralPage = lazyRetry(() => import("@/pages/app/ReferralPage"))
const AirdropPage = lazyRetry(() => import("@/pages/app/AirdropPage"))
const EditProfilePage = lazyRetry(() => import("@/pages/app/EditProfilePage"))
const LoginPage = lazyRetry(() => import("@/pages/app/LoginPage"))
const CommunityPage = lazyRetry(() => import("@/pages/app/CommunityPage"))
const SignalsPage = lazyRetry(() => import("@/pages/app/SignalsPage"))

function App() {
	return (
		<AppProviders>
			<Routes>
				<Route
					element={
						<ErrorBoundary>
							<Suspense fallback={<Spinner />}>
								<WorldEntryPage />
							</Suspense>
						</ErrorBoundary>
					}
					path="/world"
				/>
				<Route
					element={
						<ErrorBoundary>
							<Suspense fallback={<Spinner />}>
								<LoginPage />
							</Suspense>
						</ErrorBoundary>
					}
					path="/login"
				/>

				<Route
					element={
						<ErrorBoundary>
							<Suspense fallback={<Spinner />}>
								<AppLayout />
							</Suspense>
						</ErrorBoundary>
					}
					path="/"
				>
					<Route
						element={
							<Suspense fallback={null}>
								<FeedPage />
							</Suspense>
						}
						index
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<SignalsPage />
							</Suspense>
						}
						path="signals"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<PostPage />
							</Suspense>
						}
						path="post/:id"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<FollowListPage />
							</Suspense>
						}
						path="user/:handle/followers"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<FollowListPage />
							</Suspense>
						}
						path="user/:handle/following"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<UserPage />
							</Suspense>
						}
						path="user/:handle"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<SearchPage />
							</Suspense>
						}
						path="search"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<NotificationsPage />
							</Suspense>
						}
						path="notifications"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<WalletPage />
							</Suspense>
						}
						path="wallet"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<WalletTokensPage />
							</Suspense>
						}
						path="wallet/tokens"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<ReferralPage />
							</Suspense>
						}
						path="referrals"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<AirdropPage />
							</Suspense>
						}
						path="airdrop"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<EditProfilePage />
							</Suspense>
						}
						path="profile/edit"
					/>
					<Route
						element={
							<Suspense fallback={null}>
								<CommunityPage />
							</Suspense>
						}
						path="community/:ticker"
					/>
				</Route>
			</Routes>
		</AppProviders>
	)
}

export default App
